module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/book-open-effebd538656b14b08b143ef14f57c46.svg";